export const COMBINATIONS = [
    {
        id: 0,
        title: "Serpent Sage",
        trait : [
            {
            traitId: 0,
            image: "images/body-accessory/familiar-serpent.png",
            name: "Body Accessory: Familiar Serpent",    
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Familiar Serpent",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Familiar%2520-%2520Serpent%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/mouth/serpent.png", 
            name: "Mouth: Serpent",
            altText: "The Deadly Sins CNFT Trait: Mouth: Serpent",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Serpent%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/marking/serpent.png", 
            name: "Marking: Serpent",
            altText: "The Deadly Sins CNFT Trait: Marking: Serpent",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Serpent%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/skin/dragon-scales.png", 
            name: "Skin: Dragon Scales",
            altText:  "The Deadly Sins CNFT Trait: Skin: Dragon Scales",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Dragon%2520Scales%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/tail/serpent.png", 
            name: "Tail: Serpent",
            altText: "The Deadly Sins CNFT Trait: Tail: Serpent",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Serpent%2522%255D%257D"
        },
    ],

            backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 1,
        title: "Arachnid",
        trait : [
            {
            traitId: 0,
            image: "images/body-accessory/familiar-tarantula.png",
            name: "Body Accessory: Familiar Tarantula",    
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Familiar Tarantula",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Familiar%2520-%2520Tarantula%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/mouth/spider.png", 
            name: "Mouth: Spider",
            altText: "The Deadly Sins CNFT Trait: Mouth: Spider",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Spider%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/eyes/spider.png", 
            name: "Eyes: Spider",
            altText: "The Deadly Sins CNFT Trait: Eyes: Spider",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Spider%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/wings/arachnid-legs.png", 
            name: "Wings: Arachnid Legs",
            altText:  "The Deadly Sins CNFT Trait: Wings: Arachnid Legs",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522wings%2522%253A%255B%2522Arachnid%2520Legs%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 2,
        title: "Meow Master",
        trait : [
            {
            traitId: 0,
            image: "images/body-accessory/familiar-cat.png",
            name: "Body Accessory: Familiar Cat",    
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Familiar Cat",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Familiar%2520-%2520Cat%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/headpiece/neon-meow-mask.png", 
            name: "Headpiece: Neon Meow Mask",
            altText: "The Deadly Sins CNFT Trait: Headpiece: Neon Meow Mask",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Neon%2520Meow%2520Mask%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 3,
        title: "Scarecrow",
        trait : [
            {
            traitId: 0,
            image: "images/body-accessory/familiar-crow.png",
            name: "Body Accessory: Familiar Crow",    
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Familiar Crow",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Familiar%2520-%2520Crow%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/body-accessory/dungarees.png", 
            name: "Body Accessory: Dungarees",
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Dungarees",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Dungarees%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/background/abandoned-farm.png", 
            name: "Background: Abandoned Farm",
            altText: "The Deadly Sins CNFT Trait: Background: Abandoned Farm",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Abandoned%2520Farm%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 4,
        title: "Baphomet",
        trait : [
            {
            traitId: 0,
            image: "images/body-accessory/familiar-goat.png",
            name: "Body Accessory: Familiar Goat",    
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Familiar Goat",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Familiar%2520-%2520Goat%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/headpiece/ram-horns.png", 
            name: "Headpiece: Ram Horns",
            altText: "The Deadly Sins CNFT Trait: Headpiece: Ram Horns",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Ram%2520Horns%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/body-accessory/chieftain-robe.png", 
            name: "Body Accessory: Chieftain Robe",
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Chieftain Robe",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Chieftain%2520Robe%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 5,
        title: "Puppeteer",
        trait : [
            {
            traitId: 0,
            image: "images/mouth/stitches.png",
            name: "Mouth: Stitches",    
            altText: "The Deadly Sins CNFT Trait: Mouth: Stitches",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Stitches%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/skin/patchwork.png", 
            name: "Skin: Patchwork",
            altText: "The Deadly Sins CNFT Trait: Skin: Patchwork",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Patchwork%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/eyes/buttons.png", 
            name: "Eyes: Buttons",
            altText: "The Deadly Sins CNFT Trait: Eyes: Buttons",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Buttons%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/background/voodoo-island.png", 
            name: "Background: Voodoo Island",
            altText:  "The Deadly Sins CNFT Trait: Background: Voodoo Island",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Voodoo%2520Island%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 6,
        title: "Lethal",
        trait : [
            {
            traitId: 0,
            image: "images/headpiece/radioactive-horns.png",
            name: "Headpiece: Radioactive Horns",    
            altText: "The Deadly Sins CNFT Trait: Headpiece: Radioactive Horns",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Radioactive%2520Horns%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/skin/radioactive.png", 
            name: "Skin: Radioactive",
            altText: "The Deadly Sins CNFT Trait: Skin: Radioactiver",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Radioactive%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/body-accessory/hazard-suit.png", 
            name: "Body Accessory: Hazard Suit",
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Hazard Suit",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Hazard%2520Suit%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/mouth/gas-mask.png", 
            name: "Mouth: Gas Mask",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Gas Mask",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Gas%2520Mask%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 7,
        title: "Terminator",
        trait : [
            {
            traitId: 0,
            image: "images/headpiece/biotechnology.png",
            name: "Headpiece: Biotechnology",    
            altText: "The Deadly Sins CNFT Trait: Headpiece: Biotechnology",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%253A%2522%253A%255B%2522Biotechnology%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/marking/biotechnology.png", 
            name: "Marking: Biotechnology",
            altText: "The Deadly Sins CNFT Trait: Marking: Biotechnology",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Biotechnology%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/body-accessory/biotechnology.png", 
            name: "Body Accessory: Biotechnology",
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Biotechnology",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Biotechnology%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/earring/cardano-bling.png", 
            name: "Earring: Cardano Bling",
            altText:  "The Deadly Sins CNFT Trait: Earring: Cardano Bling",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Cardano%2520Bling%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/eyes/cardano.png", 
            name: "Eyes: Cardano",
            altText:  "The Deadly Sins CNFT Trait: Eyes: Cardano",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Cardano%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/body-accessory/ada-core.png", 
            name: "Body Accessory: Ada Core",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Ada Core",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Ada%2520Core%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 8,
        title: "Flamboyant",
        trait : [
            {
            traitId: 0,
            image: "images/skin/gold.png",
            name: "Skin: Gold",    
            altText: "The Deadly Sins CNFT Trait: Skin: Gold",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Gold%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/mouth/gold-tooth.png", 
            name: "Mouth: Gold Tooth",
            altText: "The Deadly Sins CNFT Trait: Mouth: Gold Tooth",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Gold%2520Tooth%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/eyes/aviator-glasses.png", 
            name: "Eyes: Aviator Glasses",
            altText: "The Deadly Sins CNFT Trait: Eyes: Aviator Glasses",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Aviator%2520Glasses%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/mouth/cigar.png", 
            name: "Mouth: Cigar",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Cigar",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Cigar%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/earring/gold-hoop.png", 
            name: "Earring: Gold Hoop",
            altText:  "The Deadly Sins CNFT Trait: Earring: Gold Hoop",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Gold%2520Hoop%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/mouth/pout.png", 
            name: "Mouth: Pout",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Pout",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Pout%2522%255D%257D",
        },
        {
            traitId: 6,
            image: "images/body-accessory/gold-chains.png", 
            name: "Body Accessory: Gold Chains",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Gold Chains",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Gold%2520Chains%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 9,
        title: "Galactic Calamity",
        trait : [
            {
            traitId: 0,
            image: "images/background/interstellar.png",
            name: "Background: Interstellar",    
            altText: "The Deadly Sins CNFT Trait: Background: Interstellar",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Interstellar%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/skin/galaxy.png", 
            name: "Skin: Galaxy",
            altText: "The Deadly Sins CNFT Trait: Skin: Galaxy",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Galaxy%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/eyes/alien.png", 
            name: "Eyes: Alien",
            altText: "The Deadly Sins CNFT Trait: Eyes: Alien",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Alien%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/earring/ufo.png", 
            name: "Earring: UFO",
            altText:  "The Deadly Sins CNFT Trait: Earring: UFO",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Ufo%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/tail/xenomorph.png", 
            name: "Tail: Xenomorph",
            altText:  "The Deadly Sins CNFT Trait: Tail: Xenomorph",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Xenomorph%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 10,
        title: "Natural Disaster",
        trait : [
            {
            traitId: 0,
            image: "images/headpiece/obsidian-horns.png",
            name: "Headpiece: Obsidian Horns",    
            altText: "The Deadly Sins CNFT Trait: Headpiece: Obsidian Horns",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Obsidian%2520Horns%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/skin/obsidian.png", 
            name: "Skin: Obsidian",
            altText: "The Deadly Sins CNFT Trait: Skin: Obsidian",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Obsidian%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/skin/magma.png", 
            name: "Skin: Magma",
            altText: "The Deadly Sins CNFT Trait: Skin: Magma",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Magma%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/background/magma-crater.png", 
            name: "Background: Magma Crater",
            altText:  "The Deadly Sins CNFT Trait: Background: Magma Crater",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Magma%2520Crater%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/headpiece/magma-horns.png", 
            name: "Headpiece: Magma Horns",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Magma Horns",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Magma%2520Horns%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 11,
        title: "Monstrous",
        trait : [
            {
            traitId: 0,
            image: "images/mouth/abyss-monster.png",
            name: "Mouth: Abyss Monster",    
            altText: "The Deadly Sins CNFT Trait: Mouth: Abyss Monster",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Abyss%2520Monster%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/eyes/abyss-monster.png", 
            name: "Eyes: Abyss Monster",
            altText: "The Deadly Sins CNFT Trait: Eyes: Abyss Monster",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Abyss%2520Monster%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/background/eyes-of-the-abyss.png", 
            name: "Background: Eyes of the Abyss",
            altText: "The Deadly Sins CNFT Trait: Background: Eyes of the Abyss",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522eyes%2520of%2520The%2520Abyss%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/wings/abyss-monster.png", 
            name: "Wings: Abyss Monster",
            altText:  "The Deadly Sins CNFT Trait: Wings: Abyss Monster",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522wings%2522%253A%255B%2522Abyss%2520Monster%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/headpiece/abyss-halo.png", 
            name: "Headpiece: Abyss Halo",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Abyss Halo",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%253A%2522%253A%255B%2522Abyss%2520Halo%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/tail/monster-mouth.png", 
            name: "Tail: Monster Mouth",
            altText:  "The Deadly Sins CNFT Trait: Tail: Monster Mouth",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Monster%2520Mouth%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 12,
        title: "Infernal",
        trait : [
            {
            traitId: 0,
            image: "images/tail/flame-red.png",
            name: "Tail: Flame",    
            altText: "The Deadly Sins CNFT Trait: Tail: Flame",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Flame%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/headpiece/inferno-flame.png", 
            name: "Headpiece: Inferno Flame",
            altText: "The Deadly Sins CNFT Trait: Headpiece: Inferno Flame",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Inferno%2520Flame%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/headpiece/soul-flame.png", 
            name: "Headpiece: Soul Flame",
            altText: "The Deadly Sins CNFT Trait: Headpiece: Soul Flame",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%253A%2522%253A%255B%2522Soul%2520Flame%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/marking/ignite.png", 
            name: "Marking: Ignite",
            altText:  "The Deadly Sins CNFT Trait: Marking: Ignite",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Ignite%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/eyes/ablaze.png", 
            name: "Eyes: Ablaze",
            altText:  "The Deadly Sins CNFT Trait: Eyes: Ablaze",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Ablaze%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 13,
        title: "Punk",
        trait : [
            {
            traitId: 0,
            image: "images/tail/pitchfork-red.png",
            name: "Tail: Pitchfork",    
            altText: "The Deadly Sins CNFT Trait: Tail: Pitchfork",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Pitchfork%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/marking/bolt.png", 
            name: "Marking: Bolt",
            altText: "The Deadly Sins CNFT Trait: Marking: Bolt",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Bolt%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/earring/crimson-trio.png", 
            name: "Earring: Crimson Trio",
            altText: "The Deadly Sins CNFT Trait: Earring: Crimson Trio",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Crimson%2520Trio%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/background/amusement-park.png", 
            name: "Background: Amusement Park",
            altText:  "The Deadly Sins CNFT Trait: Background: Amusement Park",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Amusement%2520Park%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/body-accessory/pimp-suit.png", 
            name: "Body Accessory: Pimp Suit",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Pimp Suit",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Pimp%2520Suit%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/headpiece/infernohawk.png", 
            name: "Headpiece: Infernohawk",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Infernohawk",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Infernohawk%2522%255D%257D",
        },
        {
            traitId: 6,
            image: "images/marking/cerberus-scratch.png", 
            name: "Marking: Cerberus Scratch",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Gold Chains",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Cerberus%2520Scratch%2522%255D%257D",
        },
        {
            traitId: 7,
            image: "images/earring/skull.png", 
            name: "Earring: Skull",
            altText:  "The Deadly Sins CNFT Trait: Earring: Skull",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Skull%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 14,
        title: "Misfit",
        trait : [
            {
            traitId: 0,
            image: "images/eyes/spinny-glasses.png",
            name: "Eyes: Spinny Glasses",    
            altText: "The Deadly Sins CNFT Trait: Eyes: Spinny Glasses",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Spinny%2520Glasses%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/eyes/suspicious.png", 
            name: "Eyes: Suspicious",
            altText: "The Deadly Sins CNFT Trait: Eyes: Suspicious",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Suspicious%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/mouth/sad.png", 
            name: "Mouth: Sad",
            altText: "The Deadly Sins CNFT Trait: Mouth: Sad",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522sad%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/mouth/worried.png", 
            name: "Mouth: Worried",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Worried",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Worried%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/headpiece/propeller-cap.png", 
            name: "Headpiece: Propeller Cap",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Propeller Cap",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Propeller%2520Cap%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/earring/hellpod.png", 
            name: "Earring: Hellpod",
            altText:  "The Deadly Sins CNFT Trait: Earring: Hellpod",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Hellpod%2522%255D%257D",
        },
        {
            traitId: 6,
            image: "images/eyes/night-vision-goggles.png", 
            name: "Eyes: Night Vision Goggles",
            altText:  "The Deadly Sins CNFT Trait: Eyes: Night Vision Goggles",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Night%2520Vision%2520Goggles%2522%255D%257D",
        },
        {
            traitId: 7,
            image: "images/earring/barcode-tag.png", 
            name: "Earring: Barcode Tag",
            altText:  "The Deadly Sins CNFT Trait: Earring: Barcode Tag",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Barcode%2520Tag%2522%255D%257D",
        },
        {
            traitId: 8,
            image: "images/eyes/worried.png", 
            name: "Eyes: Worried",
            altText:  "The Deadly Sins CNFT Trait: Eyes: Worried",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Worried%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 15,
        title: "Taboo",
        trait : [
            {
            traitId: 0,
            image: "images/wings/fallen-angel.png",
            name: "Wings: Fallen Angel",    
            altText: "The Deadly Sins CNFT Trait: Wings: Fallen Angel",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522wings%2522%253A%255B%2522Fallen%2520Angel%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/eyes/stoner.png", 
            name: "Eyes: Stoner",
            altText: "The Deadly Sins CNFT Trait: Eyes: Stoner",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Stoner%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/body-accessory/forbidden-gem.png", 
            name: "Body Accessory: Forbidden Gem",
            altText: "The Deadly Sins CNFT Trait: Eyes: Body Accessory: Forbidden Gem",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Forbidden%2520Gem%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/background/forbidden-runes.png", 
            name: "Background: Forbidden Runes",
            altText:  "The Deadly Sins CNFT Trait: Background: Forbidden Runes",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Forbidden%2520Runes%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/marking/cursed.png", 
            name: "Marking: Cursed",
            altText:  "The Deadly Sins CNFT Trait: Marking: Cursed",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Cursed%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/body-accessory/cursed.png", 
            name: "Body Accessory: Cursed",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Cursed",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Cursed%2522%255D%257D",
        },
        {
            traitId: 6,
            image: "images/headpiece/nero.png", 
            name: "Headpiece: Nero",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Nero",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Nero%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 16,
        title: "Mutation",
        trait : [
            {
            traitId: 0,
            image: "images/tail/split-ends-red.png",
            name: "Tail: Split Ends",    
            altText: "The Deadly Sins CNFT Trait: Tail: Split Ends",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Split%2520Ends%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/tail/leviathan.png", 
            name: "Tail: Leviathan",
            altText: "The Deadly Sins CNFT Trait: Tail: Leviathan",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Leviathan%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/marking/crescent.png", 
            name: "Marking: Crescent",
            altText: "The Deadly Sins CNFT Trait: Marking: Crescent",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Crescent%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/eyes/death-beam.png", 
            name: "Eyes: Death Beam",
            altText:  "The Deadly Sins CNFT Trait: Eyes: Death Beam",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Death%2520Beam%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/marking/elven.png", 
            name: "Marking: Elven",
            altText:  "The Deadly Sins CNFT Trait: Marking: Elven",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Elven%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/headpiece/antlers.png", 
            name: "Headpiece: Antlers",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Antlers",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Antlers%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 17,
        title: "Nightmare",
        trait : [
            {
            traitId: 0,
            image: "images/background/phantom-forest.png",
            name: "Background: Phantom Forest",    
            altText: "The Deadly Sins CNFT Trait: Background: Phantom Forest",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Phantom%2520Forest%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/tail/spectre.png", 
            name: "Tail: Spectre",
            altText: "The Deadly Sins CNFT Trait: Tail: Spectre",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Spectre%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/body-accessory/nightmare-hands.png", 
            name: "Body Accessory: Nightmare Hands",
            altText: "The Deadly Sins CNFT Trait: Body Accessory: Nightmare Hands",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Nightmare%2520Hands%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/body-accessory/phantom-tux.png", 
            name: "Body Accessory: Phantom Tux",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Phantom Tux",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Phantom%2520Tux%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/marking/nightmare.png", 
            name: "Marking: Nightmare",
            altText:  "The Deadly Sins CNFT Trait: Marking: Nightmare",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Nightmare%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/earring/antichrist.png", 
            name: "Earring: Antichrist",
            altText:  "The Deadly Sins CNFT Trait: Earring: Antichrist",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Antichrist%2522%255D%257D",
        },
        {
            traitId: 6,
            image: "images/headpiece/phantom-mask.png", 
            name: "Headpiece: Phantom Mask",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Phantom Mask",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Phantom%2520Mask%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 18,
        title: "Chaos",
        trait : [
            {
            traitId: 0,
            image: "images/headpiece/aether-horns.png",
            name: "Headpiece: Aether Horns",    
            altText: "The Deadly Sins CNFT Trait: Headpiece: Aether Horns",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Aether%2520Horns%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/tail/aether-black.png", 
            name: "Tail: Aether",
            altText: "The Deadly Sins CNFT Trait: Tail: Aether",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Aether%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/eyes/ominous-glow.png", 
            name: "Eyes: Ominous Glow",
            altText: "The Deadly Sins CNFT Trait: Eyes: Ominous Glow",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Ominous%2520Glow%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/eyes/dark-lord.png", 
            name: "Eyes: Dark Lord",
            altText:  "The Deadly Sins CNFT Trait: Eyes: Dark Lord",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Dark%2520Lord%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/mouth/ominous-glow.png", 
            name: "Mouth: Ominous Glow",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Ominous Glow",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Ominous%2520Glow%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/mouth/gnarl.png", 
            name: "Mouth: Gnarl",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Gnarl",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Gnarl%2522%255D%257D",
        },
        {
            traitId: 6,
            image: "images/mouth/haunted-pipe.png", 
            name: "Mouth: Haunted Pipe",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Haunted Pipe",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Haunted%2520Pipe%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 19,
        title: "Psycho",
        trait : [
            {
            traitId: 0,
            image: "images/marking/odium.png",
            name: "Marking: Odium",    
            altText: "The Deadly Sins CNFT Trait: Marking: Odium",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Odium%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/eyes/crazy.png", 
            name: "Eyes: Crazy",
            altText: "The Deadly Sins CNFT Trait: Eyes: Crazy",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Crazy%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/mouth/sinister.png", 
            name: "Mouth: Sinister",
            altText: "The Deadly Sins CNFT Trait: Mouth: Sinister",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Sinister%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/mouth/devour.png", 
            name: "Mouth: Devour",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Devour",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Devour%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/headpiece/bull-horns.png", 
            name: "Headpiece: Bull Horns",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Bull Horns",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Bull%2520Horns%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/body-accessory/commando.png", 
            name: "Body Accessory: Commando",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Commando",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Commando%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 20,
        title: "Possessed",
        trait : [
            {
            traitId: 0,
            image: "images/background/haunted-house.png",
            name: "Background: Haunted House",    
            altText: "The Deadly Sins CNFT Trait: Background: Haunted House",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Haunted%2520House%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/skin/zombie.png", 
            name: "Skin: Zombie",
            altText: "The Deadly Sins CNFT Trait: Skin: Zombie",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Zombie%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/marking/ender-eye.png", 
            name: "Marking: Ender Eye",
            altText: "The Deadly Sins CNFT Trait: Marking: Ender Eye",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Ender%2520Eye%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/eyes/blind.png", 
            name: "Eyes: Blind",
            altText:  "The Deadly Sins CNFT Trait: Eyes: Blind",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Blind%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/eyes/hypnotized.png", 
            name: "Eyes: Hypnotized",
            altText:  "The Deadly Sins CNFT Trait: Eyes: Hypnotized",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Hypnotized%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/body-accessory/eyes-within.png", 
            name: "Body Accessory: Eyes Within",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Eyes Within",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Eyes%2520Within%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 21,
        title: "Corrupt",
        trait : [
            {
            traitId: 0,
            image: "images/marking/crowned.png",
            name: "Marking: Crowned",    
            altText: "The Deadly Sins CNFT Trait: Marking: Crowned",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Crowned%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/marking/immortal.png", 
            name: "Marking: Immortal",
            altText: "The Deadly Sins CNFT Trait: Marking: Immortal",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Immortal%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/eyes/monocle.png", 
            name: "Eyes: Monocle",
            altText: "The Deadly Sins CNFT Trait: Eyes: Monocle",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Monocle%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/body-accessory/corrupted-heart.png", 
            name: "Body Accessory: Corrupted Heart",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Corrupted Heart",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Corrupted%2520Heart%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/mouth/nether-rose.png", 
            name: "Mouth: Nether Rose",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Nether Rose",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Nether%2520Rose%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/headpiece/broken-horn.png", 
            name: "Headpiece: Broken Horn",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Broken Horn",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Broken%2520Horn%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 22,
        title: "Chilled",
        trait : [
            {
            traitId: 0,
            image: "images/skin/ice.png",
            name: "Skin: Ice",    
            altText: "The Deadly Sins CNFT Trait: Skin: Ice",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522skin%2520type%2522%253A%255B%2522Ice%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/mouth/smirk.png", 
            name: "Mouth: Smirk",
            altText: "The Deadly Sins CNFT Trait: Mouth: Smirk",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Smirk%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/headpiece/hellbrero.png", 
            name: "Headpiece: Hellbrero",
            altText: "The Deadly Sins CNFT Trait: Headpiece: Hellbrero",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Hellbrero%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/mouth/bubblegum.png", 
            name: "Mouth: Bubblegum",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Bubblegum",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Bubblegum%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/earring/radiant-bar.png", 
            name: "Earring: Radiant Bar",
            altText:  "The Deadly Sins CNFT Trait: Earring: Radiant Bar",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Radiant%2520Bar%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/body-accessory/hawaiian-shirt.png", 
            name: "Body Accessory: Hawaiian Shirt",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Hawaiian Shirt",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Hawaiian%2520Shirt%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 23,
        title: "Conjurer",
        trait : [
            {
            traitId: 0,
            image: "images/earring/ritual-bone.png",
            name: "Earring: Ritual Bone",    
            altText: "The Deadly Sins CNFT Trait: Earring: Ritual Bone",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Ritual%2520Bone%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/marking/pentagram.png", 
            name: "Marking: Pentagram",
            altText: "The Deadly Sins CNFT Trait: Mouth: Marking: Pentagram",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Pentagram%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/body-accessory/ritual-necklace.png", 
            name: "Body Accessory: Ritual Necklace",
            altText: "The Deadly Sins CNFT Trait: Eyes: Body Accessory: Ritual Necklace",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Ritual%2520Necklace%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/body-accessory/cult-turtleneck.png", 
            name: "Body Accessory: Cult Turtleneck",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Cult Turtleneck",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522cult%2520Turtleneck%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/background/ritual-room.png", 
            name: "Background: Ritual Room",
            altText:  "The Deadly Sins CNFT Trait: Background: Ritual Room",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522background%2522%253A%255B%2522Ritual%2520Room%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/mouth/whistle.png", 
            name: "Mouth: Whistle",
            altText:  "The Deadly Sins CNFT Trait: Mouth: Whistle",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522mouth%2522%253A%255B%2522Whistle%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire1",
        tokens: 1,
    },
    {
        id: 24,
        title: "Beast Summoner",
        trait : [
            {
            traitId: 0,
            image: null,
            name: "Serpent Sage Role",    
            altText: null,
            jpgStoreLink: null,
        },
        {
            traitId: 1,
            image: null,
            name: "Arachnid Role",    
            altText: null,
            jpgStoreLink: null,
        },
        {
            traitId: 2,
            image: null,
            name: "Meow Master Role",    
            altText: null,
            jpgStoreLink: null,
        },
        {
            traitId: 3,
            image: null,
            name: "Scarecrow Role",    
            altText: null,
            jpgStoreLink: null,
        },
        {
            traitId: 4,
            image: null,
            name: "Baphomet Role",    
            altText: null,
            jpgStoreLink: null,
        },
        {
            traitId: 5,
            image: "images/body-accessory/familiar-imp.png", 
            name: "Body Accessory: Familiar Imp",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Familiar Imp",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Familiar%2520-%2520Imp%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire2",
        tokens: 3,
    },
    {
        id: 25,
        title: "Nudist",
        trait : [
            {
                traitId: 4,
                image: null,
                name: "Own at least one Deadly Sin NFT having six traits",    
                altText: null,
                jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522traitcount%2522%253A%255B%25226%2522%255D%257D",
            },
    ],

        backgroundImg: "title-column fire2",
        tokens: 3,
    },
    {
        id: 26,
        title: "Demon King",
        trait : [
            {
            traitId: 0,
            image: "images/tail/demon-king-scythes.png",
            name: "Tail: Demon King Scythes",    
            altText: "The Deadly Sins CNFT Trait: Tail: Demon King Scythes",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522tail%2522%253A%255B%2522Demon%2520King%2520Scythes%2522%255D%257D",
        },
        {
            traitId: 1,
            image: "images/wings/demon-king.png", 
            name: "Wings: Demon King",
            altText: "The Deadly Sins CNFT Trait: Wings: Demon King",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522wings%2522%253A%255B%2522Demon%2520King%2522%255D%257D",
        },
        {
            traitId: 2,
            image: "images/marking/demon-king-eye.png", 
            name: "Marking: Demon King Eye",
            altText: "The Deadly Sins CNFT Trait: Marking: Demon King Eye",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522marking%2522%253A%255B%2522Demon%2520King%2520Eye%2522%255D%257D",
        },
        {
            traitId: 3,
            image: "images/headpiece/demon-king-horns.png", 
            name: "Headpiece: Demon King Horns",
            altText:  "The Deadly Sins CNFT Trait: Headpiece: Demon King Horns",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Demon%2520King%2520Horns%2522%255D%257D",
        },
        {
            traitId: 4,
            image: "images/body-accessory/demon-king-scars.png", 
            name: "Body Accessory: Demon King Scars",
            altText:  "The Deadly Sins CNFT Trait: Body Accessory: Demon King Scars",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522body%2520accessory%2522%253A%255B%2522Demon%2520King%2520Scars%2522%255D%257D",
        },
        {
            traitId: 5,
            image: "images/earring/demon-king-rings.png", 
            name: "Earring: Demon King Rings",
            altText:  "The Deadly Sins CNFT Trait: Earring: Demon King Rings",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522earring%2522%253A%255B%2522Demon%2520King%2520Rings%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire2",
        tokens: 3,
    },
    {
        id: 27,
        title: "Emperor",
        trait : [
            {
            traitId: 0,
            image: "images/headpiece/underworld-crown.png",
            name: "Headpiece: Underworld Crown",    
            altText: "The Deadly Sins CNFT Trait: Headpiece: Underworld Crown",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522headpiece%2522%253A%255B%2522Underworld%2520Crown%2522%255D%257D",
        },
    ],

        backgroundImg: "title-column fire2",
        tokens: 6,
    },
    {
        id: 28,
        title: "Primordial",
        trait : [
            {
            traitId: 0,
            image: null,
            name: "Awarded once every trait-dependent role is attained!",    
            altText: null,
            jpgStoreLink: null,
        },
    ],

    backgroundImg: "title-column fire3",
        tokens: "41 additional",
    },
    {
        id: 29,
        title: "1/1s",
        trait : [
            {
            traitId: 0,
            image: "images/1of1s/pride.png",
            name: "Each 1/1 Deadly Sins NFT is given a special role specific to the one held",    
            altText: "The Deadly Sins CNFT: 1/1 pride",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysins?filters=%257B%2522eyes%2522%253A%255B%2522Envy%2522%252C%2522Lust%2522%252C%2522Greed%2522%252C%2522Hades%2522%252C%2522Pride%2522%252C%2522Sloth%2522%252C%2522Wrath%2522%252C%2522Gluttony%2522%252C%2522The%2520Phantom%2522%252C%2522Angel%2520In%2520Disguise%2522%255D%257D",
        },
    ],

    backgroundImg: "title-column fire3",
        tokens: 20,
    },
    {
        id: 30,
        title: "666 Club",
        trait : [
            {
            traitId: 0,
            image: null,
            name: "Own at least one Deadly Sins NFT which has a rarity rank within the top 666",    
            altText: null,
            jpgStoreLink: "https://cnft.tools/thedeadlysins",
        },
    ],

    backgroundImg: "title-column fire3",
        tokens: 6,
    },
    {
        id: 31,
        title: "Solomon's Treasure",
        trait : [
            {
            traitId: 0,
            image: null,
            name: "Own ten Deadly Sins NFTs which each have a rarity rank within the top 666",    
            altText: null,
            jpgStoreLink: "https://cnft.tools/thedeadlysins",
        },
    ],

    backgroundImg: "title-column fire3",
        tokens: 20,
    },
    {
        id: 32,
        title: "Arcane",
        trait : [
            {
            traitId: 0,
            image: null,
            name: "Be within the top 66 wallets which own the most Deadly Sins NFTs",    
            altText: null,
            jpgStoreLink: null,
        },
    ],

    backgroundImg: "title-column fire3",
        tokens: 6,
    },
    {
        id: 33,
        title: "Sacred Items",
        trait : [
            {
            traitId: 0,
            image: "images/sacred-items/amulet.png",
            name: "Sacred Amulet",    
            altText: "The Deadly Sins CNFT: Sacred Amulet",
            jpgStoreLink: "https://www.jpg.store/collection/thedeadlysinscurseditems",
        },
    ],

    backgroundImg: "title-column fire3",
        tokens: 8,
    },

]